export enum LicenseAllocationTab {
  KSE = 'KSE_TAB',
  KRE = 'KRE_TAB',
  TEST_CLOUD = 'TESTCLOUD_TAB',
  TEST_RESULT = 'TEST_RESULT_TAB',
}
